// Update locale on page change
document.addEventListener("turbo:load", function() {
  var lang = document.querySelector("meta[name=language]").content
  document.documentElement.lang = lang
})
